import { LUX_LOYALTY } from 'luxLoyalty/constants/base'

/** @returns the default / lowest ranked tier from program config with fallback */
function getLuxLoyaltyDefaultTier(state: App.State): App.LuxLoyaltyTier {
  const programConfig = state.luxLoyalty.programConfig.data
  if (!programConfig) return LUX_LOYALTY.DEFAULT_TIER
  return programConfig.tiersOrder[0]
}

export default getLuxLoyaltyDefaultTier
